module.exports = __webpack_public_path__ + "static/Lamentum3-0b955ba8776871d1290a4205d3109ddd.webp";